// extracted by mini-css-extract-plugin
module.exports = {"radio":"_9e1425b4d3--radio--oKY20"};